import { useGame } from '../state/useGame';
import { ItemSlot } from './ItemSlot';
import { TransferToolbar } from './TransferToolbar';

/** Inventory: fixed 28 explicit slots. Same selection model as the bank. */
export function InventoryPage() {
  const inventory = useGame((s) => s.state.inventory);
  const filled = inventory.filter(Boolean).length;

  return (
    <>
      <h1 className="page-title">Inventory</h1>
      <p className="page-subtitle">
        {filled} / 28 slots filled. Select an item, then pick a destination slot; use the
        toolbar to bank or equip it. Tap, keyboard, and drag all work.
      </p>

      <div className="bank-grid">
        {inventory.map((stack, i) => (
          <ItemSlot
            key={i}
            slotRef={{ container: 'inventory', index: i }}
            stack={stack ?? null}
            label={`Inventory slot ${i + 1}`}
          />
        ))}
      </div>

      <TransferToolbar />
    </>
  );
}
